import React, { useState, useEffect } from 'react'
import {
  Paper, Typography, Button, DialogContentText,
  Dialog, DialogActions, DialogContent, DialogTitle
} from '@material-ui/core'
import { Container } from '@material-ui/core'
import { fbDatabase } from '../../services/firebase'
import { getUrl } from '../../utils/routes'
import { useStyles } from './styles'
import { generateString } from '../../utils/misc'

import Loader from '../../baseComponents/Loader'
import EventBar from './components/EventBar'
import EventForm from '../../forms/NewsForm'
import NewsTable from './components/Table'

import './Events.css'

const Events = props => {
  const [events, setEvents] = useState([])
    , [event, setEvent] = useState(null)
    , [isFetching, setIsFetching] = useState(true)
    , [isEventFormActive, setIsEventFormActive] = useState(false)
    , [eventId, setEventId] = useState('')
    , [eventTitle, setEventTitle] = useState('')
    , classes = useStyles()

  const onEdit = event => {
    setEvent(event)
    setIsEventFormActive(true)
    console.log(event)
  }

  const onDelete = () => {
    const eventRef = fbDatabase.ref('CCE_NEWS').child(eventId)
    eventRef.remove()
    setEventId('')
    setEventTitle('')
  }

  const onRequestDeletion = (id, title) => {
    setEventTitle(title)
    setEventId(id)
  }

  const onReset = () => {
    setEvent(null)
    setIsEventFormActive(false)
  }

  useEffect(() => {
    const eventsRef = fbDatabase.ref('CCE_NEWS')
    eventsRef.on('value', snapshot => {
      let eventSnapshot = snapshot.val()
        , eventList = []

      for (let id in eventSnapshot)
        eventList.push({ id, ...eventSnapshot[id] })

      // eventList = eventList.sort((a, b) => a.id - b.id)
      setEvents(eventList)
      setIsFetching(false)
    })
  }, [])

  if (isFetching) return <Loader />

  if (isEventFormActive) {
    let lastId = Boolean(event) ? event.id : `${generateString(8)}${Date.now()}`

    return <Container maxWidth='xl'>
      <EventForm
        isNewEvent={!event}
        event={event}
        id={lastId}
        onSubmit={onReset}
        onCancel={onReset} />
    </Container>
  }


  return <div id='events'>
    <EventBar onShowForm={() => setIsEventFormActive(true)} />
    <Paper className={classes.paper}>
      <NewsTable rows={events} onEdit={onEdit} onDelete={onRequestDeletion} />
    </Paper>
    <Dialog
      open={Boolean(eventId.length)}
      onClose={() => setEventId('')}
    >
      <DialogTitle >¿Desea eliminar {eventTitle}?</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          Advertencia: al dar click sobre eliminar, todos los datos se eliminan inmediatamente. Esta acción es irreversible.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button className={`${classes.btn} ${classes.btnCancel}`} onClick={() => setEventId('')} variant='contained'>
          Cancelar
        </Button>
        <Button className={`${classes.btn} ${classes.btnDelete}`} onClick={onDelete} variant='contained' autoFocus>
          Eliminar
        </Button>
      </DialogActions>
    </Dialog>
  </div>
}

export default Events